"use strict";

require("core-js/features/object/assign");

require("core-js/features/array/from");

require("core-js/es/promise");

require("core-js/es/typed-array/uint8-array");

require("core-js/web/url");

require("webcrypto-shim");

var _textEncoding = require("text-encoding");

// Polyfills objects needed to support IE 11+
window.TextEncoder = window.TextEncoder || _textEncoding.TextEncoder;
window.TextDecoder = window.TextEncoder || _textEncoding.TextDecoder;
//# sourceMappingURL=polyfill.js.map